import styled from "styled-components"
import ListArrow from "../../images/BulletIcon.svg"
import BreakpointUp from "../../components/Media/BreakpointUp"

export const Section = styled.section`
	position: relative;	
	background-image: ${props=>props.bgImg};
	background-color: ${props=>props.bgColor};	
	background-size:${props => props.bgSize};
	text-align: ${props=>props.textAlign};
	overflow: ${props=>props.overflow};
	border-bottom:${props=>props.bdrWidth} solid ${props=>props.bdrColor};
	box-shadow: ${props=>props.boxShadow};
	&:before{
		content:'';
		display:${props => (props.bgBefore ? 'block' : 'none')};
		position:absolute;
		top:${props => props.topBefore};
		right:${props => props.rightBefore};
		bottom:${props => props.bottomBefore};
		right:${props => props.leftBefore};
		background:${props => props.bgBefore};
		background-size:${props => props.bgBeforeSize};
		background-repeat: ${props => props.bgBeforeRepeat};
		width:${props => props.bgBeforeWidth};
		height:${props => props.bgBeforeHeight};
		opacity:${props => props.opacityBefore};
	}
	&:after{
		content:'';
		display:${props => (props.bgAfter ? 'block' : 'none')};
		position:absolute;
		top:${props => props.topAfter};
		right:${props => props.rightAfter};
		bottom:${props => props.bottomAfter};
		right:${props => props.leftAfter};
		background:${props => props.bgAfter};
		background-size:${props => props.bgAfterSize};
		background-repeat: ${props => props.bgAfterRepeat};
		width:${props => props.bgAfterWidth};
		height:${props => props.bgAfterHeight};
		opacity:${props => props.opacityAfter};
	}
	padding-top: ${props=>props.pt};
	padding-bottom: ${props=>props.pb};

	@media (min-width: 1024px){
		padding-top: ${props=>props.mpt};
		padding-bottom: ${props=>props.mpb};	
	}
	@media (min-width: 1600px){
		padding-top: ${props=>props.xpt};
		padding-bottom: ${props=>props.xpb};	
	}
`
Section.defaultProps = {
	bgImg: "inherit",
	bgColor: "transparent",
	bgSize: "inherit",
	textAlign: "left",
	pt: "30px",
	pb: "30px",
	bdrColor:"transparent",
	bdrWidth: "0",
	boxShadow:"none"
}


export const SectionPageTitle = styled.h1`
  max-width: ${props=>props.maxWidth};
	color: ${props=>props.color};
	text-align: ${props=>props.textAlign};
	margin-top: ${props=>props.mt};	
	margin-bottom: ${props=>props.mb};	
	margin-left:${props=>props.ml};
	margin-right:${props=>props.mr};
	width:100%;
	position: relative;
`

SectionPageTitle.defaultProps = {
  textAlign: "left",
	color: "#000",
	maxWidth: "100%",
	mt: "auto",
	mr: "auto",
	ml: "auto",
	mb: "15px"
}

export const SectionTitle = styled.h2`
  max-width: ${props=>props.maxWidth};
	color: ${props=>props.color};
	text-align: ${props=>props.textAlign};
	margin-top: ${props=>props.mt};	
	margin-bottom: ${props=>props.mb};	
	margin-left:${props=>props.ml};
	margin-right:${props=>props.mr};
	padding-left:${props=>props.pl};
	padding-right:${props=>props.pr};
	width:100%;
	position: relative;
`

SectionTitle.defaultProps = {
  textAlign: "left",
	color: "#000",
	maxWidth: "100%",
	mt: "auto",
	mr: "0px",
	ml: "0px",
	mb: "15px",
	pl: "0px",
	pr: "0px"
}


export const Form = styled.div`
  width: 100%;
  margin-bottom:0;
`
export const FormGroup = styled.div`
  position: relative;
  margin-bottom: ${(props) => props.mb};
  @media (max-width: 767px) {
    margin-bottom: 15px;
  }
`
FormGroup.defaultProps = {
  mb: "30px",
}

export const FormGroupAction = styled.div`
  position: relative;
  margin-top: ${(props) => props.mt};  
`
FormGroupAction.defaultProps = {
  mt: "30px",
}


export const RightSidebar = styled.div`
  position:relative;
  width: 100%;
  background-color: #fff;
  border: 1px solid #d6ecff;
  border-radius: 8px;
  box-shadow: 0 15px 35px rgba(0, 89, 178, 0.1);
  padding: 30px 20px 50px;
  margin-bottom: 30px;
  ${BreakpointUp.md`
		padding:40px 40px 70px;
	`}
  ${BreakpointUp.lg`		
		padding:40px 50px 70px;
	`}
  .form-group{
    margin-bottom:0;
  }
`
export const SidebarTitle = styled.strong`
  display: block;
  font-family: 'UniNeueBold', sans-serif;
  font-weight: 800;
  margin-bottom: 10px;
  color: #000;
  font-size: 20px;
  line-height: 30px;
  @media (min-width: 768px) {
    font-size: 22px;
    line-height: 32px;
  }
  @media (min-width: 992px) {
    font-size: 24px;
    line-height: 34px;
  }
`
export const SidebarBtnTool = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: -24px;
  @media (min-width: 768px) {
    bottom: -29px;
  }
  button, > a {
    max-width: 330px;
    width: 100%;
    margin: 0 auto;
    display: block;
    .btn {
      display: block;
    }
  }

`


export const BaseButton = styled.span`
  display: inline-flex;
  align-items: center;
  position: relative;
  text-align: center;
  border-radius: 8px;
  border: 1px solid transparent;
  justify-content: center;
  font-family: 'UniNeueBold', sans-serif;
  font-weight: 700;
  cursor: pointer;
  font-size: 18px;
  line-height: 28px;
  padding: 9px 30px;
  @media (min-width: 1600px) {
    font-size: 20px;
    padding: 14px 30px;
  }

  > .text {
    line-height: 28px;
    + .icon {
      margin-left: 10px;
    }
  }
  > .icon {
    height: 28px;
    display: inline-flex;
    vertical-align: middle;
    align-items: center;
    + .text {
      margin-left: 10px;
    }
    &:empty {
      display: none;
    }
  }
`

export const Container = styled.div`
  position: ${(props) => props.position};
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: ${(props) => props.pr};
  padding-left: ${(props) => props.pl};
  max-width: ${(props) => props.maxWidth};
  overflow: ${(props) => props.overflow};
`
Container.defaultProps = {
  maxWidth: "1350px",
  overflow: "inherit",
  pr: "20px",
  pl: "20px",
  position: "relative",
}

export const MarkdownContent = styled.div`
  display: ${(props) => props.display};
  max-width: ${(props) => props.maxWidth};
  width: 100%;
  padding-left: ${(props) => props.pl};
  padding-right: ${(props) => props.pr};
  margin-left: ${(props) => props.ml};
  margin-right: ${(props) => props.mr};
  
  h2,
  h3 {
    margin: 0 0 5px;
    padding-top: 10px;
    @media (min-width: 768px) {
      padding-top: 20px;
    }
    @media (min-width: 992px) {
      padding-top: 30px;
    }
  }

  h2, .h2 {
    font-size: 24px;
    line-height: 32px;
    @media (min-width: 768px) {
      font-size: 32px;
      line-height: 44px;
    }
    @media (min-width: 992px) {
      font-size: 34px;
      line-height: 48px;
    }
  }

  h3, .h3 {
    font-size: 20px;
    line-height: 30px;
    @media (min-width: 768px) {
      font-size: 24px;
      line-height: 32px;
    }
    @media (min-width: 992px) {
      font-size: 28px;
      line-height: 36px;
    }
  }

  & a{
    color:#0059b2;
    &:hover, &:focus{
      color:#FAB702;
    }
  }

  & p {
    text-align: ${(props) => props.textAlign};
    color: ${(props) => props.color};
  }
  
  & ul,
  & ol {
    list-style: none;
    margin: 0 0 30px;
    padding: 0;
    font-family: 'UniNeueBold', sans-serif;
    font-weight: 700;
    font-size: 16px;
    line-height: 30px;
    color: #000;
    & li {
      padding-left: 25px;
      vertical-align: text-top;
      margin: 0;
      + li {
        margin-top: 6px;
      }
      &:before {
        content: url(${ListArrow});
        display: inline-block;
        margin-left: -25px;
        width: 25px;
        vertical-align: top;
      }
    }
  }
`

MarkdownContent.defaultProps = {
  textAlign: "left",
  maxWidth: "none",
  pl: "0",
  pr: "0",
  ml: "auto",
  mr: "auto",
  display: "block",
}

export const Flex = styled.div`
  position: relative;
  display: flex;   
  flex-wrap: wrap;
  margin:0 ${(props) => props.mLR};
  z-index: ${(props) => props.zIndex};
  align-items: ${(props) => props.alignItem};
  justify-content: ${(props) => props.justifyContent};
`
Flex.defaultProps = {
  zIndex: "1",
  alignItem:"inherit",
  justifyContent:"inherit",
  mLR:"-15px",
}

export const FlexTwoCol = styled.div`
  position: relative;
  width: 100%;
  padding:0 ${(props) => props.pLR};
  ${BreakpointUp.md`
    flex: 0 0 ${(props) => props.flexWidth};
    max-width: ${(props) => props.flexMWidth};  
	`}
`
FlexTwoCol.defaultProps = {
  flexWidth: "50%",
  flexMWidth: "50%",
  pLR: "15px",
}

export const FlexVwCol = styled.div`
  position: relative;
  width: 100%;
  padding:0 15px;
  ${BreakpointUp.md`
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
	`}
`
FlexVwCol.defaultProps = {
  
}

export const HeroWrap = styled.div`
  position: relative;
  padding-top: ${(props) => props.pt};
  padding-bottom: ${(props) => props.pb};
  background: ${(props) => props.bg};
  z-index: ${(props) => props.zIndex};
  @media (max-width: 1024px) {
    padding-top: ${(props) => props.mpt};
    padding-bottom: ${(props) => props.mpb};
  }
  @media (max-width: 768px) {
    background: ${(props) => props.mbg};
  }
`
HeroWrap.defaultProps = {
  pt: "110px",
  pb: "60px",
  mpt: "70px",
  mpb: "40px",
}

export const BreadCrumb = styled.div`
  position:  ${(props) => props.position};
  max-width: ${(props) => props.maxWidth};
  margin: auto;
  margin-top: ${(props) => props.mt};
  margin-bottom: ${(props) => props.mb};
  margin-left: ${(props) => props.ml};
  z-index: ${(props) => props.zIndex};
  font-family: 'UniNeueBold', sans-serif;
  font-weight: 700;
  font-size: 12px;
  line-height: 24px;
  color: #9b9ea2;
  white-space: nowrap;
  overflow: auto hidden;
  width:100%;
  padding-bottom: 5px;
  @media (min-width: 992px) {
    font-size: 14px;
    line-height: 28px;
  }
  & a {
    color: #000;
    &:hover {
      color: #0059b2;
    }
  }
  & span {
    padding-right: 10px;
    margin-right: 10px;
    border-right: 2px solid #9b9ea2;
  }
  &.white{
    color:#fff;
    & a{
      color:#fff;
      &:hover, &:focus{
        color:#FAB702;
      }
    }
  }
`
BreadCrumb.defaultProps = {
  position:"relative",
  zIndex: "2",
  mb: "20px",
}

export const Label = styled.div`
  position: relative;
  font-size: ${(props) => props.fSize};
  line-height: ${(props) => props.lHeight};
  color: ${(props) => props.color};
  font-weight: ${(props) => props.fWeight};
  margin-top: ${(props) => props.mt};
  margin-bottom: ${(props) => props.mb};
`
Label.defaultProps = {
  fSize: "14px",
  fWeight: "700",
  lHeight: "24px",
  color: "#9B9EA2",
}

export const Background = styled.div`
  position: absolute;
  top: ${(props) => props.top};
  right: ${(props) => props.right};
  left: ${(props) => props.left};
  z-index: ${(props) => props.zIndex};
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  max-height: ${(props) => props.maxHeight};
  background: ${(props) => props.bg};
  transform: ${(props) => props.ts};
  .gatsby-image-wrapper {
    position: relative;
    height: 100%;
    width: 100%;
  }
`
Background.defaultProps = {
  width: "60%",
  height: "100%",
  top: "0",
}

export const TwoGridWrap = styled.div`
  position: relative;
  display: flex;
  align-items: ${(props) => props.alignItems};
  z-index: ${(props) => props.zIndex};
  max-width: ${(props) => props.maxWidth};
  margin: auto ;
  @media (max-width: 768px) {
    display: block;
  }
`
TwoGridWrap.defaultProps = {
  alignItems: "center",
  zIndex: "1",
}
export const LeftWrap = styled.div`
  width: ${(props) => props.width};
  margin-right: ${(props) => props.mr};
  @media (max-width: 768px) {
    width: 100%;
  }
  
`
LeftWrap.defaultProps = {
  width: "47.5%",
  mr: "2.5%",
}
export const RightWrap = styled.div`
  width: ${(props) => props.width};
  margin-left: ${(props) => props.ml};
  transform: translateX(${(props) => props.tsx});
  .gatsby-image-wrapper {
    height: 30vw;
    max-height: ${(props) => props.maxHeight};
    width: 100%;
    border-radius: 8px;
  }
  @media (max-width: 768px) {
    margin-top: ${(props) => props.mMt};
    width: 100%;
    transform: none;
    .gatsby-image-wrapper {
      min-height: 300px;
    }
  }
  @media (max-width: 480px) {
    .gatsby-image-wrapper {
      min-height: 250px;
    }
  }
`
RightWrap.defaultProps = {
  width: "50%",
  maxHeight: "495px",
  mMt: "40px",
}

export const Triangle = styled.div`
  position: relative;
  box-sizing: border-box;
  background: ${(props) => props.bg};
  box-shadow: 0px 25px 65px rgba(1, 9, 32, 0.2);
  display: ${(props) => props.display};
  & :after {
    content: "";
    position: absolute;
    top: ${(props) => props.top};
    left: ${(props) => props.left};
    width: 0;
    height: 0;
    box-sizing: border-box;
    border: 0.5em solid;
    border-color: transparent transparent ${(props) => props.bg};
    transform-origin: 0 0;
    transform: ${(props) => props.ts};
    box-shadow: -3px 3px 4px -2px rgba(0, 0, 0, 0.1);
  }
  @media (max-width: 768px) {
    & :after {
      top: ${(props) => props.mtop};
    }
  }
  @media (max-width: 600px) {
    display: ${(props) => props.mdisplay};
  }
`
Triangle.defaultProps = {
  ts: "rotate(135deg)",
  left: "55%",
}

export const Arrow = styled.div`
  position: absolute;
  top: 100%;
  height: 24px;
  transform: translateX(-50%);
  left: 50%;
  display: ${(props) => props.display};
  &:after {
    top: 100%;
    left: 50%;
    border: solid transparent;
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: rgba(215, 231, 245, 0);
    border-top-color: #D7E7F5;
    border-width: 24px;
    margin-left: -24px;
  }
`
export const ArrowUp = styled.div`
  position:relative;
  display: ${(props) => props.display};
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  &:after {
    bottom: 100%;
    left: 50%;
    border: solid transparent;
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: rgba(255, 255, 255, 0);
    border-bottom-color: #fff;
    border-width: 15px;
    margin-left: -15px;
  }
`
export const LeftGradient = styled.div`
  position: absolute;
  z-index: 3;
  width: ${(props) => props.width};
  left: -1px;
  top: 0;
  height: 100%;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 0.9),
    rgba(255, 255, 255, 0)
  );
`
LeftGradient.defaultProps = {
  width: "30%",
}
export const RightGradient = styled.div`
  position: absolute;
  z-index: 3;
  width: 30%;
  right: -1px;
  top: 0;
  height: 100%;
  background: linear-gradient(
    to left,
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 0.9),
    rgba(255, 255, 255, 0)
  );
`
export const TopGradient = styled.div`
  position: absolute;
  z-index: 3;
  width: 100%;
  left: 0;
  top: -1px;
  height: ${(props) => props.height};
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 0.9),
    rgba(255, 255, 255, 0)
  );
`
TopGradient.defaultProps = {
  height: "30%",
}
export const BottomGradient = styled.div`
  position: absolute;
  z-index: 3;
  width: 100%;
  left: 0;
  bottom: 0;
  height: 30%;
  background: linear-gradient(
    to top,
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 0.9),
    rgba(255, 255, 255, 0)
  );
`

export const WriterWrap = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${(props) => props.mt};
  margin-bottom: ${(props) => props.mb};
  margin-left: ${(props) => props.ml};
  width: ${(props) => props.width};
`
WriterWrap.defaultProps = {
  mt: "30px",
  mb: "0px",
}
export const Avatar = styled.div`
  width: 50px;
  height: 50px;
  & .gatsby-image-wrapper {
    object-fit: contain;
    width: 50px;
    height: 50px;
    border-radius: 50px;
    border: 2px solid #fab702;
  }
`
export const Writer = styled.div`
  margin-left: 15px;
  .author, .role {
    color: #fff;
    display:block;
    line-height:24px;
  }
  & .author{
    display:block;
    color:#FAB702;
    font-size:16px;
    font-weight:700;
    margin-bottom:0;
  }
  & .role{
    font-size:14px;
    font-weight:600;
    &.text-muted{
      color:#666;
    }
  }
  & strong {
    color: #fab702;
  }
  & p {
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 0;
    color: ${(props) => props.color};
    & svg {
      vertical-align: middle;
    }
  }
`

Writer.defaultProps = {
  color: "#666666",
}

export const SocialList = styled.div`
  position: relative;
  margin:0 -5px;
  padding:0;
  display:flex;
  align-items:center;
  margin-bottom:15px;
`
export const SocialIcon = styled.div`
  position: relative;  
  padding: 0 5px;
  margin-bottom:0;
  > a{
    display:flex !important;
    width:40px !important;
    height:40px;
    align-items:center;
    justify-content:center;
    border: 1px solid #DEDEDE;
    border-radius: 8px;
    > svg{
      fill:#9B9EA2;
    }
    &:hover, &:focus{
      border-color:#000;
      > svg{
        fill:#000;
      }
    }
  }
`

export const BackgroundImg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(${(props) => props.bg});
  background-size: cover;
  background-position: center center;
`

export const Badge = styled.div`
  position: relative;
  z-index: 2;
  margin-bottom: ${(props) => props.mb};
  color: ${(props) => props.color};
  background: ${(props) => props.bg};
  border: ${(props) => props.color};
  border-radius: 40px;
  cursor: pointer;
  font-family: 'UniNeueBold', sans-serif;
  font-weight: 700;
  text-align: center;
  padding: 5px 15px;
  margin: 5px;
  font-size: 14px;
  line-height: 28px;
  @media (min-width: 1200px) {
    padding: 10px 20px;
  }
  &:hover {
    background: #fab702;
    color: #fff;
  }
`

export const CustomValidationMessage = styled.div`
  position: absolute;
  display: ${(props) => props.display};
  top: ${(props) => props.top};
  left: ${(props) => props.left};
  width: 160px;
  background: white;
  padding: 5px 10px;
  border-radius: 5px;
  margin-top: -15px;
  margin-left: 20px;
  color: #ed602b;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 1px 2px 20px rgba(0, 0, 0, 0.2);
`

export const RequiredTriangle = styled.div`
  position: absolute;
  top: -7px;
  left: 20px;
  border-top: 15px solid white;
  border-right: 15px solid white;
  transform: rotate(-45deg);
`